import type { JobDetails } from '@seek/hirer-job-information';

import type {
  JobQuery,
  JobSalaryCurrency,
  SalaryType,
} from 'src/graphql/__generated__';

import type { JobSalary } from './type';

type MapSalaryInput = {
  salaryText?: string | null | undefined;
  payType?: string | null | undefined;
  minSalary: number;
  maxSalary?: number;
  salaryCurrency?: JobSalaryCurrency | null | undefined;
  salaryIsHidden: boolean;
};

const mapSalary = (job: MapSalaryInput): JobSalary | undefined => {
  const { minSalary, maxSalary, payType, salaryCurrency, salaryText } = job;

  if (typeof minSalary !== 'number') {
    return undefined;
  }

  return {
    salaryType: payType as SalaryType,
    salaryMin: minSalary,
    salaryMax: maxSalary ?? undefined,
    salaryCurrency: salaryCurrency ?? 'AUD',
    salaryIsHidden: !Boolean(salaryText),
  };
};

export const mapJobDetails = (
  jobResponse?: JobQuery['job'],
): JobDetails | undefined => {
  if (jobResponse?.__typename !== 'JobResponseSuccess') {
    return undefined;
  }
  const job = jobResponse.result;
  const locations = job.locations.map(
    (location: { description: any }) => location.description,
  );

  return {
    id: job.id,
    createdDate: job.createdDate,
    locations,
    adType: job.adType ?? undefined,
    productDisplayName: job.productDisplayName ?? undefined,
    salary: mapSalary({
      salaryText: job.salaryText,
      payType: job.payType,
      minSalary: job.minSalary,
      maxSalary: job.maxSalary,
      salaryCurrency: job.salaryCurrency,
      salaryIsHidden: false,
    }),
    workType: job.workType ?? undefined,
    expiryDate: job.expiryDate ?? undefined,
    internalReference: job.advertiserJobReference ?? undefined,
    createdBy: job.owner?.fullName,
    classification: job.categoryName
      ? {
          categoryName: job.categoryName,
          subCategoryName: job.subCategoryName ?? undefined,
        }
      : undefined,
    status: job.status,
    workArrangement: job.workArrangements?.[0] ?? undefined,
  };
};
